// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__28mSq","clinicsSelect":"TableHeading_clinicsSelect__OINJO"};